module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox",
    class: {
      disabled: _vm.isDisabled
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": _vm.id,
      "name": _vm.name,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": function($event) {
        _vm.onChange()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.id))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-719aeb74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/check-box/CheckBox.vue
// module id = 569
// module chunks = 0